import React from 'react';
import Logo from '../assets/logo.svg';
import Mail from '../assets/Mail.png';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="line mb-5"></div>
      <div></div>
      <div className='mb-0 mb-sm-5 pb-2 w-100 mt-2 d-sm-flex d-block justify-content-between padding-left padding-right'>
        <div className='pb-5 p-sm-0'>
          <img src={Logo} alt="SafeU Cybersecurity Logo" className="logo-image" />
        </div>
        <div className='d-flex align-items-center'>
          <img src={Mail} alt="SafeU Cybersecurity Logo software" />
          <p className='ps-3 mb-1'>contact@safeu.ai</p>
        </div>
      </div>

      <div className='padding-right padding-left pt-5'>
        <div className="line mb-5"></div>
        <div className='d-flex justify-content-between'>
          <div>
            <p>© 2025 SafeU - {t('allRightsReserved')}</p>
          </div>
          {/* Uncomment and update if needed */}
          {/* <div className='d-flex mb-5'>
            <div className='ms-4 footer-button'>{t('privacyPolicy')}</div>
            <div className='ms-4 footer-button'>{t('termsOfService')}</div>
            <div className='ms-4 footer-button'>{t('cookiesSettings')}</div>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
